 module.exports = {
    "formName":"register",
    "showButtons":"top",
    "properties": [
      {
        "component":"div", 
        "type": "text",
        "format":"string",
        "text" : "Employee Details",
        "style":{"font-size":"20px", "margin-top":"1rem"}
      } ,
      {
        "component":"TextField", 
        "type": "text", 
        "minLength": 1,
        "maxLength": 50,
        "grid":6,
        "name":"cnUserFirstName",
        "label":"First Name",
        "placeholder":"First Name"
      },  
      {
        "component":"TextField", 
        "type": "text", 
        "minLength": 1,
        "maxLength": 50,
        "grid":6,
        "name":"cnUserLastName",
        "label":"Last Name",
        "placeholder":"Last Name"
      },  
      {
        "component":"TextField", 
        "type": "text",
        "format":"email", 
        "minLength": 1,
        "maxLength": 50,
        "grid":6,
        "name":"cnUserEmail",
        "label":"User Email",
        "placeholder":"User Email"
      },   
      {
        "component":"TextField", 
        "type": "text",
        "format":"number",
        "minLength": 1,
        "maxLength": 10,
        "validationLength":10,
        "grid":6,
        "name":"cnUserMobile",
        "label":"Phone Number",
        "placeholder":"Phone Number"
      },
      {
        "component":"TextField", 
        "type": "text",
        "format":"string",
        "minLength": 1,
        "maxLength": 50,
        "grid":6,
        "name":"cnUserAddress1",
        "label":"Address 1",
        "placeholder":"Address 1"
      }  ,
      {
        "component":"TextField", 
        "type": "text",
        "format":"string",
        "minLength": 1,
        "maxLength": 50,
        "grid":6,
        "name":"cnUserAddress2",
        "label":"Address 2",
        "placeholder":"Address 2"
      }   ,
      {
        "component":"TextField", 
        "type": "text",
        "format":"string",
        "minLength": 1,
        "maxLength": 50,
        "grid":6,
        "name":"cnUserCity",
        "label":"City",
        "placeholder":"City"
      }  ,
      {
        "component":"Select", 
        "type": "text",
        "format":"string",
        "minLength": 1,
        "maxLength": 50,
        "grid":6,
        "name":"cnUserState",
        "data":"/lookup/getStates",
        "dataformat":{
            "label":"stateName",
            "value":"id"
        },
        "label":"State ",
        "placeholder":"State",
        "onChange":"onStateChange"
      } , 
      {
        "component":"TextField", 
        "type": "text",
        "format":"number",
        "minLength": 1,
        "maxLength": 5,
        "validationLength":5,
        "grid":6,
        "name":"cnUserZipCode",
        "label":"Zipcode",
        "placeholder":"Zipcode",
        "validations":[
          "number"
        ]
      },
      {
        "component":"TextField", 
        "type": "text",
        "format":"number", 
        "minLength": 1,
        "maxLength": 4,
        "grid":6,
        "name":"cnUserCode",
        "label":"Staff Id",
        "placeholder":"Staff Id",
        "validations":[
          "number"
        ]
      },
      {
        "component":"Select", 
        "type": "text",
        "format":"string", 
        "minLength": 1,
        "maxLength": 50,
        "grid":6,
        "name":"cnUserRole",
        "data":"cnEmployees/getRoles",
        "dataformat":{
            "label":"roleName",
            "value":"roleId"
        },
        "label":"Role",
        "placeholder":"Role",
        "onChange":"onUpdateRole"
      },
      {
        "component":"Select", 
        "type": "text",
        "format":"string", 
        "minLength": 1,
        "maxLength": 50,
        "grid":6,
        "name":"cnUserRegion", 
        "data":"region/getRegions",
        "dataformat":{
            "label":"regionCode",
            "value":"id"
        },
        "label":"Region",
        "placeholder":"Region"
      }, 
      {
        "component":"Permission", 
        "permissionType":"Admin",
        "permissions":[
          {
              key:"Region",
              label:"Region Management",
              options:[
                  {
                      "label":"Read",
                      "Value" :"R"
                  },
                  {
                      "label":"Write",
                      "Value" :"W"
                  }
              ]
          },
          {
              key:"User",
              label:"User Management",
              subLevel:[
                  {
                      key:"Staff",
                      label:"Staff Management",
                      options:[
                          {
                              "label":"Read",
                              "Value" :"R"
                          },
                          {
                              "label":"Write",
                              "Value" :"W"
                          }
                      ]
                  },
                  {
                      key:"MasterAgents",
                      label:"Master Agents Management",
                      options:[
                          {
                              "label":"Read",
                              "Value" :"R"
                          },
                          {
                              "label":"Write",
                              "Value" :"W"
                          }
                      ]
                  },
                  {
                      key:"Agents",
                      label:"Agents Management",
                      options:[
                          {
                              "label":"Read",
                              "Value" :"R"
                          },
                          {
                              "label":"Write",
                              "Value" :"W"
                          }
                      ]
                  }
              ]
          },
          {
              key:"Merchant",
              label:"Merchant Management",
              subLevel:[
                  {
                      key:"Create",
                      label:"Create Merchant",
                      options:[
                          {
                              "label":"Allow",
                              "Value" :"Y"
                          } 
                      ]
                  },
                  {
                      key:"Review",
                      label:"Review Merchant",
                      subLevel:[
                          {
                              key:"AssignToMe",
                              label:"Assign To Me",
                              options:[
                                  {
                                      "label":"Allow",
                                      "Value" :"Y"
                                  } 
                              ]
                          }, 
                          {
                              key:"AssignToStaff",
                              label:"Assign To Staff",
                              options:[
                                  {
                                      "label":"Allow",
                                      "Value" :"Y"
                                  } 
                              ]
                          }, 
                          {
                              key:"AssignToMA",
                              label:"Assign To Master Agent",
                              options:[
                                  {
                                      "label":"Allow",
                                      "Value" :"Y"
                                  } 
                              ]
                          }, 
                          {
                              key:"AssignToA",
                              label:"Assign To Agent",
                              options:[
                                  {
                                      "label":"Allow",
                                      "Value" :"Y"
                                  } 
                              ]
                          }, 
                          {
                              key:"Unassign",
                              label:"Unassign",
                              options:[
                                  {
                                      "label":"Allow",
                                      "Value" :"Y"
                                  } 
                              ]
                          }, 
                          {
                              key:"EditMerchant",
                              label:"Edit Merchant",
                              options:[
                                  {
                                      "label":"Allow",
                                      "Value" :"Y"
                                  } 
                              ]
                          }, 
                      ]
                  },
                  {
                      key:"Rejected",
                      label:"Rejected Merchants",
                      options:[
                          {
                              "label":"Show All",
                              "Value" :"All"
                          } ,
                          {
                              "label":"Show Assigned",
                              "Value" :"Assigned"
                          } 
                      ]
                  },
                  {
                      key:"Deactivated",
                      label:"Deactivated Merchants",
                      options:[
                          {
                              "label":"Show All",
                              "Value" :"All"
                          } ,
                          {
                              "label":"Show Assigned",
                              "Value" :"Assigned"
                          } 
                      ]
                  }
              ]
          }
      ] 
      } ,
    ],
    "required": ["cnUserFirstName", "cnUserLastName","cnUserEmail","cnUserMobile","cnUserCode","cnUserRole", "cnUserRegion", "cnUserState"],
    "buttons":[
      {
        "label":"Save",
        "type":"submit",
        "variant":"contained",
        "grid":2
      },
      {
        "label":"Cancel",
        "type":"close",
        "variant":"outlined",
        "grid":2
      }
    ],
    "onSubmit":{  
        "action":"API",
        "url":"cnEmployees/saveEmployee",
        "method":"POST",
        "onSuccess":{
            "action":"reloadData"
        } 
    }
  }